<template>
  <form class=" vr360-auth__registration" @submit.prevent="handlerRegister">
    <h1 class="vr360-head-h1 vr360-auth-main__title">Registration</h1>

    <input-text :placeholder="'Your Email'"
                :type="'email'"
                :isCentered="true"
                v-model="user.email"/>

    <input-text :placeholder="'Create a password'"
                :type="'password'"
                :isCentered="true"
                v-model="user.password"/>

    <input-text :placeholder="'Repeat a password'"
                :type="'password'"
                :isCentered="true"
                v-model="user.confPassword"/>

    <button class="vr360-btn" type="submit">
      <span>Submit</span>
    </button>
  </form>
</template>

<script>
import { mapActions } from 'vuex';
import InputText from "../partials/InputText";

export default {
  name: 'Register',
  components: {
    InputText
  },
  data() {
    return {
      user: {
        email: '',
        passsword: '',
        confPassword: ''
      }
    };
  },
  methods: {
    ...mapActions({
      registerUser: 'user/registerUser'
    }),
    handlerRegister() {
      this.registerUser({
        email: this.user.email,
        password: this.user.password
      });
    }
  }
};
</script>